import React from 'react';

export default function NewsletterRendererV2({ newsletter_v2 }) {
  if (!newsletter_v2) return null;

  const {
    header:            h  = {},
    intro:             it = {},
    sections               = [],
    deals                  = [],
    cta                    = {},
    signoff:           sg  = {},
    branding_snapshot: bs  = {},
  } = newsletter_v2;

  const showDeals = deals.length > 0;
  const showCta   = cta.visible && cta.text;

  return (
    <div className="bg-white rounded-xl overflow-hidden border border-gray-200 max-w-2xl mx-auto">

      {/* 1. Header */}
      <div className="px-8 py-8" style={{ backgroundColor: 'var(--brand)' }}>
        <h1 className="text-[22px] font-semibold text-white leading-tight tracking-tight">
          {h.headline || '—'}
        </h1>
        {h.preheader && (
          <p className="text-white/60 italic text-sm mt-2 leading-relaxed">{h.preheader}</p>
        )}
        {bs.agency_name && (
          <p className="text-white/35 text-xs mt-4 font-normal">{bs.agency_name}</p>
        )}
      </div>

      <div className="px-8 py-7 space-y-7">

        {/* 2. Intro */}
        {it.body && (
          <p className="text-gray-600 text-sm leading-relaxed">{it.body}</p>
        )}

        {/* 3. Content sections */}
        {sections.map((s, i) => (
          <div key={i} className="space-y-3">
            {s.photo_url && (
              <div className="rounded-lg overflow-hidden">
                <img
                  src={s.photo_url}
                  alt={s.title || ''}
                  className="w-full h-44 object-cover"
                  onError={e => { e.target.style.display = 'none'; }}
                />
              </div>
            )}
            <h3 className="text-sm font-semibold text-gray-900">{s.title}</h3>
            {s.highlight && (
              <p className="text-sm text-gray-500 italic border-l-2 pl-4 leading-relaxed"
                style={{ borderColor: 'var(--brand)' }}>
                {s.highlight}
              </p>
            )}
            <p className="text-sm text-gray-600 leading-relaxed">{s.body}</p>
          </div>
        ))}

        {/* 4. Deals */}
        {showDeals && (
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Uitgelichte aanbiedingen</h3>
            <div className="space-y-2.5">
              {deals.map((d, i) => (
                <div key={i} className="rounded-lg border border-gray-200 p-4">
                  <p className="text-sm font-medium text-gray-900">{d.destination}</p>
                  {d.tagline && (
                    <p className="text-xs text-gray-500 mt-1">{d.tagline}</p>
                  )}
                  {d.price_from && (
                    <p className="text-lg font-semibold mt-2" style={{ color: 'var(--brand)' }}>
                      Vanaf €{d.price_from}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 5. CTA */}
        {showCta && (
          <div>
            {cta.note && (
              <p className="text-sm text-gray-500 mb-3">{cta.note}</p>
            )}
            <a
              href={cta.url || '#'}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-white text-sm font-medium transition-opacity hover:opacity-90"
              style={{ backgroundColor: 'var(--brand)' }}
            >
              {cta.text}
            </a>
          </div>
        )}

        {/* 6. Signoff */}
        {sg.body && (
          <p className="text-sm text-gray-500 leading-relaxed whitespace-pre-line">{sg.body}</p>
        )}

        {/* 7. Branding footer */}
        <div className="pt-5 border-t border-gray-100 flex items-center justify-between text-xs text-gray-400">
          <div className="flex items-center gap-2">
            {bs.agency_name && <span className="font-medium text-gray-500">{bs.agency_name}</span>}
            {bs.agent_name  && <span>· {bs.agent_name}</span>}
          </div>
          <div className="flex gap-4">
            {bs.phone       && <span>📞 {bs.phone}</span>}
            {bs.website_url && <span>🌐 {bs.website_url}</span>}
          </div>
        </div>

      </div>
    </div>
  );
}
